import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Terms & Conditions - Wisdom Consultancy</title>
      </Helmet>

      <section className="bg-gray-50 py-20 min-h-screen">
        <div className="container-custom max-w-4xl bg-white rounded-3xl shadow-xl p-8 md:p-14 border border-gray-100">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#0b1c39] mb-8 border-b pb-6">
            Terms & Conditions
          </h1>

          <div className="prose prose-lg text-gray-600 max-w-none space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">1. Informational Purpose Clause</h2>
              <p>
                The information, calculators, articles, and services provided on this website are intended solely for general informational and educational purposes. Nothing on this site should be construed as personalized investment advice, research recommendation, tax advice, or legal advice.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">2. No Guaranteed Returns</h2>
              <p>
                Past performance may or may not be sustained in the future and is not a guarantee of any future returns. We do not guarantee assured returns, capital protection, or specific performance of any investment product.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">3. User Responsibility</h2>
              <p>
                Any investment decision taken by users shall be entirely at their own discretion and risk. Investors are strongly advised to evaluate their risk appetite, financial goals, liquidity requirements, and investment horizon before investing in any financial products.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">4. External Links Disclaimer</h2>
              <p>
                This website may contain links to third-party websites for investor convenience. Wisdom Consultancy does not control or endorse the content, accuracy, or availability of such external websites and shall not be responsible for any loss arising from their usage.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">5. Investment Risk Clause</h2>
              <p>
                Mutual Fund investments are subject to market risks including possible loss of principal. Please read all Scheme Information Documents (SID), Key Information Memorandum (KIM), Statement of Additional Information (SAI), and other related documents carefully before investing. Investment values may fluctuate depending on market conditions and external factors.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">6. Insurance Subjectivity Clause</h2>
              <p>
                Insurance is the subject matter of solicitation. Policy issuance and claim settlement are at the sole discretion of the respective insurance company and are governed by the applicable policy terms and underwriting guidelines. Wisdom Consultancy does not guarantee policy approval or claim settlement.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">7. Intellectual Property</h2>
              <p>
                All trademarks, logos, fund names, AMC names, and brand names displayed on this website belong to their respective owners and are used strictly for informational and identification purposes only. The content, layout, and code of this website are the property of Wisdom Consultancy.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">8. Limitation of Liability</h2>
              <p>
                Under no circumstances shall Wisdom Consultancy or its representatives be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of the use of or inability to use this website, or any errors or omissions in the content thereof.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">9. Jurisdiction</h2>
              <p>
                These Terms and Conditions shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of the courts located in Vadodara, Gujarat.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsConditions;
